import api from '.';
import logger from '../utils/logger';

export const getSearchAutoSuggestOptions = async (query: string, result_size: number) => {
  try {
    const { data } = await api.get(
      `/rental-equipment-search/equipment-classes/suggestions?search_term=${encodeURIComponent(
        query,
      )}&result_size=${result_size}`,
    );

    return data;
  } catch (error) {
    logger('error', 'at getSearchAutoSuggestOptions while fetching search auto suggest options');
    throw new Error(
      'error at getSearchAutoSuggestOptions while fetching search auto suggest options',
    );
  }
};
